export default "__VITE_PUBLIC_ASSET__d48ff2ec__"